<template>
  <div class="activation-page py-4 px-2" dir="rtl">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          
          <!-- 1. رسالة شكر السيد المحافظ -->
          <div class="card border-0 shadow-sm mb-4 governor-card overflow-hidden">
            <div class="card-body p-3 d-flex align-items-center bg-white">
              <div class="icon-box ms-3">
                <i class="fas fa-check-circle text-gold fs-2"></i>
              </div>
              <div>
                <h6 class="fw-bold mb-1 text-dark">اعتماد النتيجة رسمياً</h6>
                <p class="mb-0 small text-muted">خالص الشكر والتقدير للسيد اللواء المحافظ على اعتماد النتيجة وتوجيهاته بتوفير كافة سبل الراحة لأبنائنا الطلاب.</p>
              </div>
            </div>
          </div>

          <!-- 2. تحذير الضغط العالي (وميض) -->
          <div class="alert alert-danger shadow-sm border-2 blinking-border mb-4">
            <div class="d-flex align-items-start">
              <i class="fas fa-exclamation-triangle mt-1 ms-2"></i>
              <div>
                <h6 class="fw-bold mb-1 small-mobile-text">تحذير التشغيل المباشر</h6>
                <p class="mb-0 x-small-text">تفعيل النتيجة سيؤدي لتدفق آلاف الزوار. يرجى التأكد من جاهزية السيرفر.</p>
              </div>
            </div>
          </div>

          <!-- 3. لوحة التحكم الرئيسية -->
          <div class="card shadow-lg border-0 rounded-4 main-card">
            <div class="card-header bg-dark text-white py-3 text-center">
              <h6 class="mb-0 fw-bold"><i class="fas fa-cogs ms-2 text-warning"></i> لوحة التحكم في البوابة الرقمية</h6>
            </div>
            
            <div class="card-body p-4 p-md-5 text-center">
              <!-- أيقونة الحالة -->
              <div class="status-display mb-4">
                <div :class="settings.is_results_active ? 'pulse-green' : 'pulse-red'" class="status-circle mx-auto mb-3">
                  <i v-if="settings.is_results_active" class="fas fa-globe display-4 text-white"></i>
                  <i v-else class="fas fa-lock display-4 text-white"></i>
                </div>
                <h4 class="fw-bold">
                  {{ settings.is_results_active ? 'النتيجة متاحة للجميع' : 'النتيجة محجوبة حالياً' }}
                </h4>
              </div>

              <!-- شريط التقدم (يظهر عند التفعيل أو الإغلاق) -->
              <div v-if="showProgress" class="progress-wrapper mb-4 animate__animated animate__fadeIn">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small fw-bold text-primary">{{ progressText }}</span>
                  <span class="small fw-bold text-primary">{{ progressValue }}%</span>
                </div>
                <div class="progress" style="height: 10px;">
                  <div 
                    class="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                    role="progressbar" 
                    :style="{ width: progressValue + '%' }"
                  ></div>
                </div>
              </div>

              <!-- رسائل النجاح داخل الصفحة -->
              <div v-if="pageMessage" class="alert alert-success animate__animated animate__fadeIn py-2 mb-4 shadow-sm border-0">
                <i class="fas fa-check-circle ms-2"></i> {{ pageMessage }}
              </div>

              <div class="d-grid gap-3">
                  <!-- زر التفعيل -->
                  <button 
                    @click="handleToggle" 
                    class="btn btn-lg py-3 action-btn shadow-sm"
                    :class="settings.is_results_active ? 'btn-outline-danger' : 'btn-success'"
                    :disabled="loading || showProgress"
                  >
                    <i class="fas fa-power-off ms-2"></i>
                    {{ settings.is_results_active ? 'إغلاق البوابة (حجب)' : 'إعلان النتيجة الآن' }}
                  </button>

                  <!-- زر الواتساب -->
                  <button 
                    v-if="settings.is_results_active && !showProgress"
                    @click="runWhatsapp" 
                    class="btn btn-outline-success btn-lg py-3 action-btn border-2"
                    :disabled="broadcasting"
                  >
                    <i class="fab fa-whatsapp ms-2"></i>
                    بث النتائج عبر الواتساب
                  </button>
              </div>

              <!-- رسالة الواتساب -->
              <div v-if="whatsappInfo" class="mt-4 p-3 bg-light rounded-3 border-start border-4 border-success animate__animated animate__slideInUp">
                <p class="mb-0 text-success fw-bold small text-end">
                   بناءً على اعتماد السيد المحافظ، تم بدء إرسال "رسائل البشرى" للطلاب وأولياء الأمور عبر خدمة الواتساب الرسمية.
                </p>
              </div>
            </div>

            <div class="card-footer bg-light text-muted small text-center py-2">
              آخر تحديث: {{ settings.updated_at || 'الآن' }}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: "Blinking",
  data() {
    return {
      loading: false,
      showProgress: false,
      progressValue: 0,
      progressText: "",
      broadcasting: false,
      pageMessage: "",
      whatsappInfo: false,
      settings: {
        is_results_active: 0,
        updated_at: null
      }
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      try {
        const res = await api.get('/admin/settings');
        this.settings = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async handleToggle() {
      const newStatus = this.settings.is_results_active ? 0 : 1;
      
      // بدء عملية شريط التقدم
      this.showProgress = true;
      this.progressValue = 0;
      this.pageMessage = "";
      this.whatsappInfo = false;
      this.progressText = newStatus ? "جاري تهيئة قواعد البيانات..." : "جاري حجب الوصول...";

      // محاكاة الخطوات الأولى للشريط (إعطاء شعور بالعمل)
      const interval = setInterval(() => {
        if (this.progressValue < 90) {
          this.progressValue += Math.floor(Math.random() * 10) + 5;
          if (this.progressValue > 40) this.progressText = "تفريغ ذاكرة التخزين المؤقت (Cache)...";
          if (this.progressValue > 70) this.progressText = "تأمين الاتصالات المشفرة...";
        }
      }, 400);

      try {
        // الطلب الفعلي للباك اند
        const res = await api.post('/admin/settings/toggle-results', { status: newStatus });
        
        if (res.data.success) {
          // إنهاء الشريط بنجاح
          clearInterval(interval);
          this.progressValue = 100;
          this.progressText = "اكتملت العملية بنجاح";
          
          setTimeout(() => {
            this.showProgress = false;
            this.settings.is_results_active = newStatus;
            this.pageMessage = newStatus 
              ? "بفضل الله، النتيجة معتمدة ومتاحة للجمهور الآن." 
              : "تم حجب النتيجة بنجاح من كافة المنصات.";
          }, 800);
        }
      } catch (e) {
        clearInterval(interval);
        this.showProgress = false;
        this.pageMessage = "تعذر الاتصال بالسيرفر، يرجى المحاولة لاحقاً.";
      }
    },

    runWhatsapp() {
      this.broadcasting = true;
      this.whatsappInfo = true;
      setTimeout(() => this.broadcasting = false, 3000);
    }
  }
};
</script>

<style scoped>
/* تحسينات الموبيل */
@media (max-width: 576px) {
  .small-mobile-text { font-size: 0.95rem; }
  .x-small-text { font-size: 0.8rem; }
  .display-4 { font-size: 2.5rem; }
  .action-btn { font-size: 0.95rem; padding: 15px 5px !important; }
}

.activation-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

/* شريط التقدم */
.progress-wrapper {
  background: #f1f3f9;
  padding: 15px;
  border-radius: 12px;
}

/* الوميض للتحذير */
.blinking-border {
  border: 2px solid #dc3545;
  animation: blinker 1.5s linear infinite;
}
@keyframes blinker { 50% { opacity: 0.6; } }

/* الدوائر النابضة */
.status-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
}
.pulse-green { 
  background-color: #198754; 
  box-shadow: 0 0 0 0 rgba(25, 135, 84, 0.7);
  animation: pulse-g 2s infinite;
}
.pulse-red { 
  background-color: #dc3545;
  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  animation: pulse-r 2s infinite;
}

@keyframes pulse-g { 70% { box-shadow: 0 0 0 20px rgba(25, 135, 84, 0); } }
@keyframes pulse-r { 70% { box-shadow: 0 0 0 20px rgba(220, 53, 69, 0); } }

.text-gold { color: #d4af37; }
.governor-card { border-right: 5px solid #d4af37 !important; border-radius: 12px; }
.rounded-4 { border-radius: 1.5rem !important; }
.main-card { background: #ffffff; border: 1px solid #eee; }
.action-btn { border-radius: 12px; transition: all 0.3s; }
</style>